
import "jquery";
import "slick-carousel";

import "./js/index.js"
import "./scss/index.scss"